// extracted by mini-css-extract-plugin
module.exports = {"categoryList":"styles-module--categoryList--jASL-","label":"styles-module--label--3RX6Q","select":"styles-module--select--2x28k"};